import SelectSearch, {fuzzySearch} from "react-select-search";
import React from "react";
import {IconWrapper, SelectSearchWrapper} from "./input.styles";

const CustomSelectSearch = ({label, icon: Icon, rootClassName, ...otherProps}) => {

    return (
        <SelectSearchWrapper className={rootClassName} inputValue={otherProps.value}>
            <label className='mb-2'>{label}</label>
            <SelectSearch
                search
                filterOptions={fuzzySearch}
                {...otherProps}
            />
            {
                Icon && <IconWrapper>{Icon}</IconWrapper>
            }
        </SelectSearchWrapper>
    );
};

export default CustomSelectSearch;
